import ClientForm from '@/views/App/Client/Form.vue';
import ClientList from '@/views/App/Client/List.vue';
import SubClientList from '@/views/App/Client/SubClient/List.vue';

const routesClient = [
    {
        path: 'list',
        name: 'clientList',
        component: ClientList
    },
    {
        path: 'form/:id?',
        name: 'clientForm',
        component: ClientForm
    },

    // Sub client
    {
        path: 'sub-client-list',
        name: 'subClientList',
        component: SubClientList
    },
];

export default routesClient;